import FormControl from '@mui/material/FormControl'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import InputLabel from '@mui/material/InputLabel'
import OutlinedInput from '@mui/material/OutlinedInput'
import React from 'react'

type Props = {
  'data-testid': string
  id?: string
  searchTerm: string

  onChange: (value: string) => void
}

const SearchBar: React.FC<Props> = ({ searchTerm, onChange, ...props }) => {
  return (
    <FormControl size="small" variant="outlined" sx={{ width: '100%' }}>
      <InputLabel htmlFor={props.id}>Search</InputLabel>
      <OutlinedInput
        endAdornment={
          <InputAdornment position="end">
            {searchTerm && (
              <IconButton
                aria-label="clear search"
                onClick={() => {
                  onChange('')
                }}
                edge="end"
              >
                <Icon>close</Icon>
              </IconButton>
            )}
          </InputAdornment>
        }
        label="Search"
        size="small"
        value={searchTerm}
        onChange={(e) => {
          onChange(e.currentTarget.value)
        }}
        {...props}
      />
    </FormControl>
  )
}

export default SearchBar
